import { render, staticRenderFns } from "./ProCameraInventoryList.vue?vue&type=template&id=ca24faa2&scoped=true"
import script from "./ProCameraInventoryList.vue?vue&type=script&lang=js"
export * from "./ProCameraInventoryList.vue?vue&type=script&lang=js"
import style0 from "./ProCameraInventoryList.vue?vue&type=style&index=0&id=ca24faa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca24faa2",
  null
  
)

export default component.exports